import { useMemo } from 'react'
import { SanityContentCarouselLinkItemLink } from '@data/sanity/queries/types/blocks'
import { getPageUrl, PageType } from '@lib/routes'
import Photo from './photo'
import BaseInternalLink from './link/base-internal-link'

type LinkItemProps = Pick<
  SanityContentCarouselLinkItemLink,
  'title' | 'page' | 'image'
>

const LinkItem = ({ title, page, image }: LinkItemProps) => {
  const pageUrl = useMemo(() => {
    return getPageUrl(page.type as PageType, page.slug)
  }, [page])

  return (
    <BaseInternalLink
      href={pageUrl}
      className="relative block no-underline transition-opacity duration-200 hover:opacity-70"
    >
      <Photo image={image} />

      {!!title && (
        <div className="absolute left-0 right-0 bottom-0 p-7 text-left text-lg font-bold text-white z-10">
          {title}
        </div>
      )}
    </BaseInternalLink>
  )
}

export default LinkItem
